import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NotificationCountSearch } from '../../entities/notifications/notification-count-search.entity';
import { NotificationOutdated } from '../../entities/notifications/notification-oudated.entity';
import { NotificationSearch } from '../../entities/notifications/notification-search.entity';
import { NotificationEntity } from '../../entities/notifications/notification.entity';
import { MapObjectToHttpParams } from '../../helpers/map-obj-to-http-params.helper';
import { ApiList } from '../../record/entities/api-list.entity';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { ApiListToPaginatedResults } from '../../record/helpers/api-list-to-paginated-results.helper';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable()
export class NotificationService {
    private readonly ENDPOINT = 'notifications';
    constructor(private readonly http: AbstractHttpService) {}

    markNotificationsAsOutdated(sentBeforeDate?: Date): Observable<void> {
        const params: NotificationOutdated = {
            ...(sentBeforeDate && { SentBefore: sentBeforeDate.toISOString() })
        };
        return this.http.post<void>(`${this.ENDPOINT}/mark-as-outdated`, params);
    }

    getAll(searchParams: NotificationSearch): Observable<PaginatedResults<NotificationEntity>> {
        return this.http
            .get<ApiList<NotificationEntity>>(this.ENDPOINT, MapObjectToHttpParams(searchParams))
            .pipe(map(apiList => ApiListToPaginatedResults(apiList, searchParams.nrOfResults)));
    }

    getCount(searchParams: NotificationCountSearch): Observable<number> {
        return this.http
            .head<number>(this.ENDPOINT, MapObjectToHttpParams(searchParams))
            .pipe(map(response => Number(response.headers.get('Result-Count'))));
    }

    delete(id: string): Observable<void> {
        return this.http.delete(`${this.ENDPOINT}/${id}`);
    }

    deleteBulk(ids: string[]): Observable<void> {
        return this.http.request(`${this.ENDPOINT}`, 'delete', ids);
    }
}
